import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { breakpoint } from '../../../../grid';

import {
    NON_INPUT_X_AFFORDANCE_DESKTOP,
    NON_INPUT_X_AFFORDANCE_MOBILE,
} from '../../../../picker-constants';

import { FontFamily } from '../../../../typography';
import { renderRow } from '../Row';

const addItem = (item, context) => {
    const {
        active,
        clickHandler,
        focusState,
        selected,
        metricsAction,
        metricsStep,
        metricsDetailsIdField,
    } = context;

    return renderRow({
        ...item,
        tag: 'div',
    },
    selected,
    clickHandler,
    active && focusState,
    null,
    {
        action: metricsAction,
        eventDetails: {
            [metricsDetailsIdField]: item.id,
            Name: item.name,
            SelectionType: metricsStep,
        },
    });
};

const addAlphabetItems = context => {
    const {
        items,
    } = context;

    let current = null;
    for (; context.index < items.length; context.index++) {
        const item = items[context.index];

        if (item.name && item.name[0] !== current) {
            current = item.name[0];
            context.alphabetizedItems.push((
                <AlphabetBreaker key={`alphabet-${context.index}`}>
                    {current}
                </AlphabetBreaker>));
        }

        context.alphabetizedItems.push(addItem(item, context));
    }

    if (context.alphabetizedItems.length === (items.length + 1)) {
        context.alphabetizedItems.shift();
    }
};

const addNumericItems = context => {
    const {
        items,
    } = context;

    if (items[context.index].name && !isLetter(items[context.index].name[0])) {
        context.alphabetizedItems.push(
            <AlphabetBreaker key={`alphabet-${context.index}`}>
                #
            </AlphabetBreaker>
        );

        while (context.index < items.length
                && items[context.index].name
                && !isLetter(items[context.index].name[0])) {
            const item = items[context.index];
            context.alphabetizedItems.push(addItem(item, context));
            context.index++;
        }
    }
};

const isLetter = c => {
    return c.toLowerCase() !== c.toUpperCase();
};

const AlphabetBreaker = styled.div`
    font: 20px/28px ${FontFamily.SharpSansBold};
    color: ${navy};
    text-size-adjust: none;
    font-size: 16px;
    width: 100%;
    padding: 8px ${NON_INPUT_X_AFFORDANCE_MOBILE}px 0;

    ${breakpoint.small} {
        padding: 8px ${NON_INPUT_X_AFFORDANCE_DESKTOP}px 0;
    }
`;

export function alphabetizeItems({
    active,
    clickHandler,
    focusState,
    items,
    selected,
    metricsAction,
    metricsStep,
    metricsDetailsIdField,
}) {
    const context = {
        active,
        alphabetizedItems: [],
        clickHandler,
        focusState,
        index: 0,
        items,
        selected,
        metricsAction,
        metricsStep,
        metricsDetailsIdField,
    };

    addNumericItems(context);
    addAlphabetItems(context);

    return context.alphabetizedItems;
}
